<template>
    <footer>
        <div id="footer-main">
          <router-link
          to="/"
          tag="div"
          id="footer-left">

              <svg id="dan-emoji" width="67" height="81" viewBox="0 0 67 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.1875 17.7188L5.65625 15.1875C5.65625 15.1875 9.48603 12.1222 12.9336 9.36563C16.4141 6.58125 20.7425 5.0625 25.2026 5.0625C29.7613 5.0625 35.7579 5.0625 40.5521 5.0625C45.7614 5.0625 50.7555 7.13053 54.441 10.816C56.7217 13.0967 58.8125 15.1875 58.8125 15.1875V25.3125L57.5216 33.0607C58.3999 33.2834 59.2099 33.739 59.8604 34.3896C60.8097 35.3388 61.3438 36.6272 61.3438 37.9688C61.3438 40.2646 61.3438 43.0262 61.3438 45.5625C61.3438 48.8784 59.2175 51.6983 56.2559 52.7335C56.0636 56.5988 54.7676 60.3374 52.5097 63.4989C51.3833 65.0759 50.1278 66.8326 48.9254 68.5184C45.5994 73.1734 40.2281 75.9375 34.5074 75.9375C33.8367 75.9375 33.1633 75.9375 32.4926 75.9375C26.7719 75.9375 21.4006 73.1734 18.0746 68.5184C16.8722 66.8326 15.6167 65.0759 14.4903 63.4989C12.2324 60.3374 10.9364 56.5988 10.7441 52.7335C7.7825 51.6983 5.65625 48.8784 5.65625 45.5625C5.65625 43.0262 5.65625 40.2646 5.65625 37.9688C5.65625 36.6272 6.19034 35.3388 7.13956 34.3896C7.79009 33.739 8.60009 33.2834 9.47844 33.0607L8.1875 25.3125V17.7188V17.7188Z" stroke="black" stroke-width="10.125" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M53.75 32.9062C53.75 32.9062 54.8865 32.9062 56.2812 32.9062C57.6228 32.9062 58.9112 33.4403 59.8604 34.3896C60.8097 35.3388 61.3438 36.6272 61.3438 37.9688C61.3438 40.2646 61.3438 43.0262 61.3438 45.5625C61.3438 49.7568 57.9443 53.1562 53.75 53.1562V32.9062Z" fill="#E5B59C"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 32.9062C13.25 32.9062 12.1135 32.9062 10.7188 32.9062C9.37719 32.9062 8.08878 33.4403 7.13956 34.3896C6.19034 35.3388 5.65625 36.6272 5.65625 37.9688C5.65625 40.2646 5.65625 43.0262 5.65625 45.5625C5.65625 49.7568 9.05572 53.1562 13.25 53.1562V32.9062Z" fill="#E5B59C"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M41.5089 56.9531C42.8631 56.9531 44.1642 57.4923 45.121 58.4491L51.2137 63.2762C51.0897 63.4078 50.9631 63.5369 50.834 63.666C50.224 64.276 49.6038 64.8962 48.9938 65.5062C46.7789 67.7211 41.5215 71.8445 38.5625 72.6924H28.4375C25.4785 71.8445 20.2211 67.7211 18.0062 65.5062C17.3962 64.8962 16.776 64.276 16.166 63.666C16.0369 63.5369 15.9103 63.4078 15.7863 63.2762L21.879 58.4491C22.8358 57.4923 24.1369 56.9531 25.4911 56.9531H41.5089V56.9531ZM10.7188 40.5V32.9062C10.7188 20.3234 20.9172 10.125 33.5 10.125C46.0828 10.125 56.2812 20.3234 56.2812 32.9062V40.5L55.0156 50.5162C55.0156 54.0498 52.7451 58.7453 50.8922 61.6891L47.6522 58.4491C46.6954 57.4923 45.3943 56.9531 44.0401 56.9531H22.9599C21.6057 56.9531 20.3046 57.4923 19.3478 58.4491L16.1078 61.6891C14.2549 58.7453 11.9844 54.0498 11.9844 50.5162L10.7188 40.5V40.5Z" fill="#E5B59C"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7188 40.5H13.25V50.5162C13.25 54.0498 14.2549 57.4796 16.1078 60.4235L19.3478 57.1835C20.3046 56.2267 21.6057 55.6875 22.9599 55.6875H44.0401C45.3943 55.6875 46.6954 56.2267 47.6522 57.1835L50.8922 60.4235C52.7451 57.4796 53.75 54.0498 53.75 50.5162V40.5H56.2812V51.7286C56.2812 55.9508 54.9625 60.064 52.5097 63.4989C51.3833 65.0759 50.1278 66.8326 48.9254 68.5184C45.5994 73.1734 40.2281 75.9375 34.5074 75.9375C33.8367 75.9375 33.1633 75.9375 32.4926 75.9375C26.7719 75.9375 21.4006 73.1734 18.0746 68.5184C16.8722 66.8326 15.6167 65.0759 14.4903 63.4989C12.0375 60.064 10.7188 55.9508 10.7188 51.7286V40.5V40.5ZM41.5089 58.2188H25.4911C24.1369 58.2188 22.8358 58.7579 21.879 59.7147L18.3176 63.2762C18.4416 63.4078 18.5682 63.5369 18.6973 63.666C19.3073 64.276 19.9274 64.8962 20.5375 65.5062C22.7523 67.7211 25.4785 69.3132 28.4375 70.1612V68.3438H38.5625V70.1612C41.5215 69.3132 44.2477 67.7211 46.4625 65.5062C47.0726 64.8962 47.6927 64.276 48.3027 63.666C48.4318 63.5369 48.5584 63.4078 48.6824 63.2762L45.121 59.7147C44.1642 58.7579 42.8631 58.2188 41.5089 58.2188Z" fill="#CD9B84"/>
                  <path d="M23.375 62.0156C23.375 62.0156 24.0331 62.3447 24.8735 62.7649C27.2174 63.9368 29.8018 64.5469 32.4217 64.5469C33.1304 64.5469 33.8696 64.5469 34.5783 64.5469C37.1982 64.5469 39.7826 63.9368 42.1265 62.7649C42.9669 62.3447 43.625 62.0156 43.625 62.0156" stroke="#AB755D" stroke-width="3.79688" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M47.4219 37.9662C47.4219 37.2954 47.1561 36.6525 46.6802 36.1792C46.2069 35.7033 45.5639 35.4375 44.8932 35.4375H44.8906C43.4934 35.4375 42.3594 36.5715 42.3594 37.9688C42.3594 39.5153 42.3594 41.4847 42.3594 43.0312C42.3594 44.4285 43.4934 45.5625 44.8906 45.5625C46.2879 45.5625 47.4219 44.4285 47.4219 43.0312C47.4219 41.4847 47.4219 39.5128 47.4219 37.9662Z" fill="black"/>
                  <path class="left-eye" fill-rule="evenodd" clip-rule="evenodd" d="M24.6406 37.9688C24.6406 36.5715 23.5066 35.4375 22.1094 35.4375C20.7121 35.4375 19.5781 36.5715 19.5781 37.9688C19.5781 39.5153 19.5781 41.4847 19.5781 43.0312C19.5781 44.4285 20.7121 45.5625 22.1094 45.5625C23.5066 45.5625 24.6406 44.4285 24.6406 43.0312C24.6406 41.4847 24.6406 39.5153 24.6406 37.9688Z" fill="black"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.1875 17.7188L5.65625 15.1875C5.65625 15.1875 9.48603 12.1222 12.9336 9.36563C16.4141 6.58125 20.7425 5.0625 25.2026 5.0625C29.7613 5.0625 35.7579 5.0625 40.5521 5.0625C45.7614 5.0625 50.7555 7.13053 54.441 10.816C56.7217 13.0967 58.8125 15.1875 58.8125 15.1875V25.3125L56.2812 40.5H53.75C53.75 40.5 53.75 36.2399 53.75 34.101C53.75 33.3163 53.5677 32.5392 53.2159 31.8381C52.7856 30.9774 52.1832 29.7726 51.7528 28.9119C51.401 28.2108 51.2188 27.4337 51.2188 26.649C51.2188 25.7023 51.2188 24.2924 51.2188 22.7812C51.2188 18.587 47.8193 15.1875 43.625 15.1875C43.4352 15.1875 43.2453 15.1875 43.0555 15.1875C38.5574 15.1875 34.2442 16.9746 31.0649 20.1538C31.0624 20.1563 31.0624 20.1563 31.0624 20.1563C27.7617 23.4571 23.2839 25.3125 18.6162 25.3125H15.7812V26.649C15.7812 27.4337 15.599 28.2108 15.2472 28.9119C14.8168 29.7726 14.2144 30.9774 13.7841 31.8381C13.4323 32.5392 13.25 33.3163 13.25 34.101V40.5H10.7188L8.1875 25.3125V17.7188V17.7188Z" fill="#322A26"/>
                  <path class="right-brow" fill-rule="evenodd" clip-rule="evenodd" d="M41.0938 30.375L38.5625 34.1719C38.5625 34.1719 40.0661 34.1719 40.7546 34.1719C40.9798 34.1719 41.2051 34.1542 41.4279 34.1162C42.5442 33.9314 46.1689 33.3264 47.8345 33.048C48.3964 32.9543 48.971 32.9872 49.5177 33.1442C50.8011 33.5112 53.1172 34.1719 53.1172 34.1719C53.1172 34.1719 52.7476 33.4327 52.335 32.6076C51.6516 31.2382 50.2518 30.375 48.7229 30.375C45.7259 30.375 41.0938 30.375 41.0938 30.375V30.375Z" fill="#322A26"/>
                  <path class="left-brow" fill-rule="evenodd" clip-rule="evenodd" d="M25.9062 30.375L28.4375 34.1719C28.4375 34.1719 26.9339 34.1719 26.2454 34.1719C26.0202 34.1719 25.7949 34.1542 25.5721 34.1162C24.4558 33.9314 20.8311 33.3264 19.1655 33.048C18.6036 32.9543 18.029 32.9872 17.4822 33.1442C16.1989 33.5112 13.8828 34.1719 13.8828 34.1719C13.8828 34.1719 14.2524 33.4327 14.665 32.6076C15.3484 31.2382 16.7482 30.375 18.2771 30.375C21.2741 30.375 25.9062 30.375 25.9062 30.375V30.375Z" fill="#322A26"/>
                  <path d="M28.4375 51.8906L33.5 53.1562L38.5625 51.8906" stroke="#AB755D" stroke-width="3.79688" stroke-miterlimit="1.5" stroke-linecap="square" stroke-linejoin="round"/>
              </svg>
              <div class="copyright">
                  <h2>DAN<br>ARAUJO</h2>
                  <p>© {{ new Date().getFullYear() }} til forever</p>
              </div>

          </router-link>

          <div id="footer-right">
              <div id="footer-links">
                  <router-link to="/projects" class="footer-link">Work<span :style="{color: $store.state.activeProject.color}">.</span></router-link>
                  <router-link to="/about" class="footer-link">About<span :style="{color: $store.state.activeProject.color}">.</span></router-link>
                  <a href="mailto:dancaraujo@gmail.com" class="footer-link">Email<span :style="{color: $store.state.activeProject.color}">.</span></a>
                  <a href="https://www.linkedin.com/in/dancaraujo" target="_blank" class="footer-link">LinkedIn<span :style="{color: $store.state.activeProject.color}">.</span></a>
              </div>

              <p>A <b>Product Designer</b> and <b>Developer</b> based in <span> Chicago, IL.</span></p>

          </div>
        </div>
    </footer>
</template>

<script>
import anime from 'animejs'

export default {
  props: {

  },
  data () {
    return {

    }
  },

  mounted () {
    let leftEye = ['M24.6406 37.9688C24.6406 36.5715 23.5066 35.4375 22.1094 35.4375C20.7121 35.4375 19.5781 36.5715 19.5781 37.9688C19.5781 39.5153 19.5781 41.4847 19.5781 43.0312C19.5781 44.4285 20.7121 45.5625 22.1094 45.5625C23.5066 45.5625 24.6406 44.4285 24.6406 43.0312C24.6406 41.4847 24.6406 39.5153 24.6406 37.9688Z',
      'M28 39.75C28 39.336 25.536 39 22.5 39C19.464 39 17 39.336 17 39.75C17 40.2083 17 40.7917 17 41.25C17 41.664 19.464 42 22.5 42C25.536 42 28 41.664 28 41.25C28 40.7917 28 40.2083 28 39.75Z']
    let leftBrow = ['M25.9062 30.375L28.4375 34.1719C28.4375 34.1719 26.9339 34.1719 26.2454 34.1719C26.0202 34.1719 25.7949 34.1542 25.5721 34.1162C24.4558 33.9314 20.8311 33.3264 19.1655 33.048C18.6036 32.9543 18.029 32.9872 17.4822 33.1442C16.1989 33.5112 13.8828 34.1719 13.8828 34.1719C13.8828 34.1719 14.2524 33.4327 14.665 32.6076C15.3484 31.2382 16.7482 30.375 18.2771 30.375C21.2741 30.375 25.9062 30.375 25.9062 30.375V30.375Z',
      'M26.1387 30.7391L28.0671 34.8749C28.0671 34.8749 26.5808 34.6477 25.9002 34.5436C25.6775 34.5095 25.4575 34.458 25.243 34.3868C24.1675 34.0354 20.6758 32.8896 19.0715 32.3626C18.5301 32.1851 17.9572 32.1308 17.393 32.2033C16.0689 32.3721 13.6796 32.6751 13.6796 32.6751C13.6796 32.6751 14.1566 32.0004 14.6892 31.247C15.5717 29.9966 17.0859 29.3549 18.5972 29.586C21.5598 30.039 26.1387 30.7391 26.1387 30.7391V30.7391Z']
    let rightBrow = ['M41.0938 30.375L38.5625 34.1719C38.5625 34.1719 40.0661 34.1719 40.7546 34.1719C40.9798 34.1719 41.2051 34.1542 41.4279 34.1162C42.5442 33.9314 46.1689 33.3264 47.8345 33.048C48.3964 32.9543 48.971 32.9872 49.5177 33.1442C50.8011 33.5112 53.1172 34.1719 53.1172 34.1719C53.1172 34.1719 52.7476 33.4327 52.335 32.6076C51.6516 31.2382 50.2518 30.375 48.7229 30.375C45.7259 30.375 41.0938 30.375 41.0938 30.375V30.375Z',
      'M40.8126 27.9733L39.0801 32.1949C39.0801 32.1949 40.5541 31.8983 41.229 31.7625C41.4499 31.7181 41.6673 31.6562 41.8781 31.5751C42.936 31.1737 46.3702 29.8656 47.9481 29.2641C48.4805 29.0614 49.0503 28.9803 49.6173 29.0263C50.9478 29.133 53.3487 29.3237 53.3487 29.3237C53.3487 29.3237 52.8406 28.6721 52.2734 27.9445C51.3332 26.7368 49.7907 26.1667 48.2918 26.4683C45.3537 27.0595 40.8126 27.9733 40.8126 27.9733V27.9733Z']

    let wink = anime.timeline({
      easing: 'easeOutBack',
      autoplay: false,
      duration: 750
    })

    wink
      .add({
        targets: '.right-brow',
        d: [{ value: rightBrow[0] }, { value: rightBrow[1] }]
      })
      .add({
        targets: '.left-brow',
        d: [{ value: leftBrow[0] }, { value: leftBrow[1] }]
      }, '-=650')
      .add({
        targets: '.left-eye',
        d: [{ value: leftEye[0] }, { value: leftEye[1] }]
      }, '-=650')
      .add({
        targets: '#dan-emoji',
        rotate: -9,
        duration: 500
      }, '-=750')

    let hoverOn = () => {
      if (wink.reversed) wink.reverse()
      console.log(wink)
      wink.play()
    }

    let hoverOff = () => {
      if (!wink.reversed) wink.reverse()
      wink.play()
    }

    let footerLeft = document.querySelector('#footer-left')
    footerLeft.addEventListener('mouseenter', hoverOn, false)
    footerLeft.addEventListener('mouseleave', hoverOff, false)
  }
}

</script>

<style lang="scss" scoped>

footer {
    background: $white;
    margin-top: 80px;
    width: 100vw;

    @include tablet-below {
      margin-top: 10px;
    }
}

#footer-main {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    box-shadow: 0 15vh 0 0 $white;
    box-sizing: border-box;
    @extend %container;

    @include phone-only {
      flex-direction: column;
      align-items: flex-start;
    }

    #footer-left {
        @extend %linkify;
        display: flex;
        align-items: center;

        .copyright {
            margin-left: 20px;

            h2 {
                color: $black;
                font-family: $display-font;
                font-size: 2rem;
                line-height: 1.75rem;

                @include tablet-below {
                  font-size: 1.5rem;
                  line-height: 1.5rem;
                }

            }

            p {
                margin-top: 2px;
                font-size: 0.75rem;
                color: $gray6;
            }
        }

    }

    #footer-right {
        @include tablet-only {
          width: 360px;
        }

        @include phone-only {
          width: 100%;
        }

        #footer-links {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;

            @include phone-only {
              justify-content: flex-start;
              margin-top: 1.5rem;
            }

            .footer-link {
                font-size: 1rem;
                text-decoration: none;
                text-transform: uppercase;
                margin-left: 2rem;
                font-weight: bold;
                color: $gray8;

                @include tablet-only {
                  margin-left: 1rem;
                }

                @include phone-only {
                  margin-right: 1rem;
                  margin-left: 0;
                  font-size: .875rem;
                }

                &:hover {
                  color: $gray5;
                }

            }
        }

        p {
            color: $gray6;
            text-align: right;

            @include phone-only {
              text-align: left;
            }

            span {
              white-space: nowrap;
            }

        }
    }
}

</style>
